import ApolloClient from 'apollo-boost';

export const getClient = (token?: string) => {
  const client = new ApolloClient({
    uri: process.env.REACT_APP_GQL_URL,
    headers: { auth: token }
  });

  return client;
}